import React, { useState } from 'react';
import { RiMenu3Line, RiCloseLine} from 'react-icons/ri';
import logo from '../../assets/logo.png';
import './navbar.css';


const Navbar = () => {
    let text='Enter App';
    
    const [toggleMenu, setToggleMenu] = useState(false);

    return (
      <div className="gpt3__navbar " >
        <div className="gpt3__navbar-links">
          <div className="gpt3__navbar-links_logo">
            <img src={logo} />
          </div>
          <div className="gpt3__navbar-links_container ml-36">
            <p><a href="#header">Home</a></p>
            <p><a href="#whitepaper">Whitepaper</a></p>
            <p><a href="#about">About</a></p>
            <p><a href="#features">Features</a></p>
            {/* <p><a href="#extra">extra</a></p> */}
            <p><a href="#roadmapsec">Roadmap</a></p>
            {/* <p><a href="#team">Team</a></p> */}
            <p><a href="#partners">Partners</a></p>
          </div>
        </div>
        <div className="gpt3__navbar-sign">
        {/* <button class="relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-purple-600 to-blue-500 group-hover:from-purple-600 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800">
            <span class="relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                JOIN NOW !
            </span>
          </button> */}
        </div>
        <div className="gpt3__navbar-menu">
          {toggleMenu
            ? <RiCloseLine color="#fff" size={27} onClick={() => setToggleMenu(false)} />
            : <RiMenu3Line color="#fff" size={27} onClick={() => setToggleMenu(true)} />}
          {toggleMenu && (
          <div className="gpt3__navbar-menu_container scale-up-center">
            <div className="gpt3__navbar-menu_container-links">
              <p><a href="#header">Home</a></p>
              <p><a href="#whitepaper">Whitepaper</a></p>
              <p><a href="#about">About</a></p>
              <p><a href="#features">Features</a></p>
              {/* <p><a href="#extra">extra</a></p> */}
              <p><a href="#roadmapsec">Roadmap</a></p>
              {/* <p><a href="#team">Team</a></p> */}
              <p><a href="#partners">Partners</a></p>
            </div>
            <div className="gpt3__navbar-menu_container-links-sign">
              <button type="button">Launch App</button>
            </div>
          </div>
          )}
        </div>
      </div>
    );
  };

export default Navbar

